import { DateTime } from "../DateTime/DateTime";

export class DataConverter {
    // ========================================================================
    static toBoolean(val: string, truthyVal?: unknown): boolean {
        const regExp = truthyVal ? String(truthyVal) : /\b(X|Y|1|true)\b/i;
        const length = truthyVal && typeof regExp === "string" ? regExp.length : val === "true" ? 4 : 1;
        return val?.length === length && new RegExp(regExp).test(val);
    }

    // ========================================================================
    static toNumber(val: string): number {
        const convertedValue = Number(val);
        // eslint-disable-next-line no-restricted-globals
        return isNaN(convertedValue) ? 0 : convertedValue;
    }

    static toDate(format: DateTime.StringFormats): (val: string) => Date {
        return (val) => {
            try {
                return DateTime.fromString(val, format);
            } catch (error: unknown) {
                console.error(`Error parsing date "${val}" to format "${format}"`);
                return new Date(0);
            }
        };
    }

    // ========================================================================
    static nullable = {
        toArray(val: string): null | string[] {
            return val ? DataConverter.toArray(val) : null;
        },
        toString(val: string): null | string {
            return val.trim() || null;
        },
        toNumber(val: string): null | number {
            return val ? DataConverter.toNumber(val) : null;
        },
        toDate(format: DateTime.StringFormats): (val: string) => null | Date {
            return (val) => {
                if (val === "") return null;
                try {
                    return DateTime.fromString(val, format);
                } catch (error: unknown) {
                    console.error(`Error parsing date "${val}" to format "${format}"`);
                    return null;
                }
            };
        },
        toBoolean(val: string, truthyVal?: unknown): null | boolean {
            return val === "" || val === null || val === undefined ? null : DataConverter.toBoolean(val, truthyVal);
        },
        getEnumValuesAsArray(e: Record<string, number | string>): Array<null | number | string> {
            const enumVals = Object.values(e);
            const isStringValueEnum = Object.values(e).length === enumVals.length && Object.values(e).every((v) => typeof v === "string");
            const values = isStringValueEnum ? enumVals : enumVals.slice(enumVals.length / 2);
            return [null, ...values];
        },
    };

    // ========================================================================
    static toArray(val: string): string[] {
        const arr = [];
        for (let i = 0; i < val.length; i++) {
            arr.push(val[i]);
        }
        return arr;
    }

    // ========================================================================
    private constructor() {
        throw new Error("Not Implemented");
    }
}

// ========================================================================
export declare namespace DataConverter {}
